import type { SignedFileInfo, SignFailedFileInfo } from '../types';

/**
 * 批量获取文件签名地址请求参数
 */
export interface SignFilesRequest {
    /** S3文件键列表 */
    s3_keys: string[];
}

/**
 * 批量获取文件签名地址响应
 */
export interface SignFilesResponse {
    /** 签名成功的文件列表 */
    signed_files: SignedFileInfo[];
    /** 签名失败的文件列表 */
    failed_files: SignFailedFileInfo[];
    /** 总文件数 */
    total_count: number;
    /** 成功签名数 */
    success_count: number;
    /** 失败签名数 */
    failed_count: number;
}

export const SignFilesApi = Symbol.for('SignFilesApi');

/**
 * 批量获取文件签名地址 API 接口
 * @description 提供批量获取S3文件签名地址的 API 调用
 */
export interface SignFilesApi {
    /**
     * 批量获取文件签名地址
     * @param request 文件签名请求参数
     * @returns 文件签名响应
     */
    signFiles(request: SignFilesRequest): Promise<SignFilesResponse>;
}
